/* eslint-disable @typescript-eslint/no-explicit-any */
export const isEmpty = (array: any[]): boolean => array.length === 0;
